import React from 'react';

// Styles
import styles from './PatientContentButtons.module.css';

// Components
import PatientButtons from '../PatientButtons/PatientButtons';
import PatientContent from '../PatientContent/PatientContent';

// Interfaces
import { Case, IScoreCircle } from '../../../interfaces/Patient';

// Other
import { useLocation } from 'react-router-dom';

interface Props {
    caso: Case;
    updateScore: (cv: IScoreCircle) => void;
    refreshPatientSilently: () => Promise<void>;
}

const PatientContentButtons: React.FC<Props> = ({
    caso,
    updateScore,
    refreshPatientSilently
}) => {
    const location = useLocation();

    const getCurrentTab = () => {
        const path = location.pathname.split('/').at(-1);
        if (path === 'patients_charts') return 'patients_charts';
        if (path === 'patients_data_table') return 'patients_data_table';
        if (path === 'patients_polls') return 'patients_polls';
        if (path === 'pharmacy') return 'pharmacy';
        if (path === 'clinical_course') return 'clinical_course';
        if (path === 'calendar') return 'calendar';
        if (path === 'additional_data') return 'additional_data';
        return '';
    };

    const currentTab = getCurrentTab();

    return (
        <>
            <div className={styles.buttonsHandlerContainer}>
                <PatientButtons currentTab={currentTab} />
                <div className={styles.searchbarContainer} id='patient-buttons-right'></div>
            </div>

            <PatientContent
                caso={caso}
                updateScore={updateScore}
                refreshPatientSilently={refreshPatientSilently}
            />
        </>
    );
};

export default PatientContentButtons;